<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="420px"
    :lock-scroll="false"
    :close-on-click-modal="false"
    :close-on-press-escape="!loading"
    :show-close="!loading"
    custom-class="ele-dialog-form"
    @close="onClose">
    <div v-loading="loading && percent === 0">{{ tip }}</div>
    <el-progress
      style="margin-top: 16px"
      :percentage="percent"
      :status="percent >= 100 ? 'success' : undefined" />
    <div style="margin-top: 10px; color: #909399; font-size: 13px">
      {{ processed }} / {{ total }}
    </div>
    <div slot="footer">
      <el-button v-if="loading" @click="cancel">取消</el-button>
      <el-button v-else type="primary" @click="visible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ExportProgressDialog',
  props: {
    title: { type: String, default: '导出数据' },
    biz: { type: String, required: true }
  },
  data() {
    return {
      visible: false,
      loading: false,
      aborted: false,
      taskId: '',
      filename: '',
      tip: '',
      percent: 0,
      processed: 0,
      total: 0
    };
  },
  methods: {
    start(params = {}) {
      if (this.loading) {
        this.visible = true;
        return;
      }
      this.run(params);
    },
    async run(params) {
      this.visible = true;
      this.loading = true;
      this.aborted = false;
      this.taskId = '';
      this.tip = '正在导出...';
      this.percent = 0;
      this.processed = 0;
      this.total = 0;

      try {
        const startRes = await this.$http.post('/Export/start', { biz: this.biz, ...params });
        if (startRes.data.code !== 0) {
          // 无数据：直接关掉，不弹提示
          if (this.isEmptyExportMsg(startRes.data.msg)) {
            this.visible = false;
            return;
          }
          throw new Error(startRes.data.msg || '导出失败');
        }
        const data = startRes.data.data || {};
        this.taskId = data.task_id;
        this.filename = data.filename || `${this.biz}.csv`;
        this.total = Number(data.total || 0);

        while (!this.aborted) {
          const chunkRes = await this.$http.post('/Export/chunk', { task_id: this.taskId });
          if (chunkRes.data.code !== 0) {
            if (this.isEmptyExportMsg(chunkRes.data.msg)) {
              this.visible = false;
              return;
            }
            throw new Error(chunkRes.data.msg || '导出失败');
          }
          const chunk = chunkRes.data.data || {};
          this.processed = Number(chunk.processed || 0);
          this.total = Number(chunk.total || this.total);
          this.percent = Number(chunk.percent || 0);
          if (chunk.done) break;
        }

        if (this.aborted) {
          this.tip = '已取消';
          if (this.taskId) {
            await this.$http.post('/Export/cancel', { task_id: this.taskId });
          }
          return;
        }

        this.tip = '正在下载...';
        this.percent = 100;
        const fileRes = await this.$http.post(
          '/Export/download',
          { task_id: this.taskId },
          { responseType: 'blob' }
        );
        await this.saveBlob(fileRes);
        this.visible = false;
      } catch (e) {
        this.visible = false;
        if (this.taskId) {
          this.$http.post('/Export/cancel', { task_id: this.taskId }).catch(() => {});
        }
      } finally {
        this.loading = false;
      }
    },
    async saveBlob(res) {
      const blob = res.data;
      const type = (res.headers && (res.headers['content-type'] || res.headers['Content-Type'])) || '';
      if (type.indexOf('json') !== -1 || (blob.type && blob.type.indexOf('json') !== -1)) {
        const text = await (blob.text ? blob.text() : new Response(blob).text());
        let msg = '下载失败';
        try {
          msg = JSON.parse(text).msg || msg;
        } catch (e) { /* ignore */ }
        throw new Error(msg);
      }
      const url = URL.createObjectURL(new Blob([blob]));
      const a = document.createElement('a');
      a.href = url;
      a.download = this.filename || 'export.csv';
      a.click();
      URL.revokeObjectURL(url);
    },
    isEmptyExportMsg(msg) {
      const text = String(msg || '');
      return text.indexOf('没有可导出') !== -1
        || text.indexOf('暂无数据') !== -1
        || text.indexOf('无数据') !== -1;
    },
    cancel() {
      this.aborted = true;
      this.tip = '正在取消...';
    },
    onClose() {
      if (this.loading) this.aborted = true;
    }
  }
};
</script>
